module.exports = __webpack_public_path__ + "img/drop-up2.56edd546.svg";